import React, { memo } from 'react';
import { Icon } from '@core/js/components/common/Icon';
import { Button } from '@core/js/components/common/Button';
import style from './NevisPasskeysNoItem.scss';
import { NevisPasskeysListContainer } from './NevisPasskeysListContainer';
import { CREATE_PASSKEYS_BUTTON, PASSKEYS_DESKTOP_INFO } from '../../constants';
import { INevisPasskeysSwissNoItemProps } from '../../types';

export const NevisPasskeysDesktop = memo(({
    tkPrefix,
    isDisabled,
    t,
    createPassKey
} : INevisPasskeysSwissNoItemProps) => (
    <div className={style.noPassKeyContainer}>
        <div className={style.createPasskeysContainer}>
            <div className={style.iconWrapper}>
                <Icon className={style.passKeyIcon}/>
                <Button className={style.createPasskeyBtn}
                        onClick={createPassKey}
                        disabled={isDisabled}>
                    {t(CREATE_PASSKEYS_BUTTON)}
                </Button>
            </div>
            <NevisPasskeysListContainer
                tkPrefix={tkPrefix}
                values={PASSKEYS_DESKTOP_INFO}
                t={t}/>
        </div>
    </div>
));
